module.exports = __webpack_public_path__ + "img/Group-32712-1-1.aa0ee150.png";